import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
    const token = localStorage.getItem("authToken"); // Get token

    return token ? <Outlet /> : <Navigate to="/login" />; // If no token -> redirect
};

export default ProtectedRoute;